import {
  actionUploadPaymentDetailsSubmit,
  resetSubmitPaymentDetails,
} from "./../../routes/app/auth/quotes_list/store/index";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { TOAST_DURATION, TOAST_SUCCESS_COLOR } from "../../common/app_constant";
import toast from "react-hot-toast";
import $ from "jquery";
import ErrorLabel from "../error_label";

const UploadPaymentDetailsPopup = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    reset,
  } = useForm();

  const { SubmitPaymentDetails } = useSelector((state) => ({
    ...state.quoteListStore,
  }));

  const validateFileType = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileType = file.type;
      if (fileType !== 'application/pdf') {
        alert('Please select a PDF file.');
        event.target.value = null; // Clear the selection
      }
    }
  };

  const initialRender = () => {
    if (props.show === true) {
      $("#root").addClass("modal-open");
      $("#root").append('<div class="modal-backdrop fade show"></div>');
    } else {
      $("#root").removeClass("modal-open");
      $(".modal-backdrop").remove();
      reset();
    }
  };
  useEffect(initialRender, [props.show]);

  useEffect(() => {
    dispatch(resetSubmitPaymentDetails());
    if (SubmitPaymentDetails?.status) {
      props.handleClose();
      toast.success(SubmitPaymentDetails.message, {
        duration: TOAST_DURATION,
        position: TOAST_DURATION,
        style: {
          color: TOAST_SUCCESS_COLOR,
        },
      });
      navigate("/policies");
      window.location.reload();
    } else if (SubmitPaymentDetails?.status == false) {
      toast('please try after some time')
    }
  }, [SubmitPaymentDetails]);

  const onSubmit = (data) => {
   
    // Valid document types
    const validTypes = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg'];

    // Check if the uploaded document is valid
    if (!data.document || !validTypes.includes(data.document[0].type)) {
      setError('document', {
        message: 'Please select a valid document format',
        type: 'manual'
      }, {
        shouldFocus: true
      })
      return;
    }
    data.id = props?.newData?.id
    var input = {
      ...data
    }

    // Prepare files for actionUploadClaimDoc
    var files = [];
    if (data?.document != null) {
      files.push({
        name: "file",
        value: data.document[0],
      });
    }
    if(data?.tax_invoice_document != null){
      files.push({
        name: "file",
        value: data.tax_invoice_document[0],
      });
    }

    delete input.document
    delete input.tax_invoice_document
  
    dispatch(actionUploadPaymentDetailsSubmit({ files, input }));
  };

  return (
    <>
      {/* Modal */}
      <div
        class="modal fade show"
        id="modaluploadPaymentDetails"
        tabindex="-1"
        aria-labelledby="modaluploadPaymentDetails"
        aria-hidden="true"
        style={{ display: `${props.show === true ? "block" : "none"}` }}
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="modaluploadPaymentDetails">
                Payment Details
              </h5>
              <button
                type="button"
                class="btn-close"
                aria-label="Close"
                onClick={() => {
                  props.handleClose();
                }}
              ></button>
            </div>
            <div class="modal-body">
              <form
                noValidate
                autoComplete="Off"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div class="mb-2">
                  <label for="amount" class="form-label">
                    Amount :{" "}
                    <span className="text-primary">{props.amount}</span>
                  </label>
                </div>
                <div class="mb-3">
                  <label for="neft_reference_no" class="form-label">
                    Ref. No
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="neft_reference_no"
                    {...register("neft_reference_no", {
                      required: "This is required.",
                    })}
                    placeholder="Enter Number"
                  />
                  {errors.neft_reference_no && (
                    <ErrorLabel message={errors.neft_reference_no?.message} />
                  )}
                </div>
                <div className="col-12 mt-3">
                  <label htmlFor="formFile" className="form-label">
                    Attachment<span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="file"
                    accept=".pdf, .jpg, .jpeg, .png"
                    name="document"
                    {...register("document", {
                      required: "This is required.",
                    })}
                  />
                  {errors.document && (
                    <ErrorLabel message={errors.document?.message} />
                  )}
                </div>
                <div className="col-12">
                  <small className="fs-7">Only pdf, jpg, jpeg, png allowed.
                  </small>
                </div>
                <div className="col-12 mt-3">
                  <label htmlFor="formFile" className="form-label">
                    Vehicle Tax Invoice<span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="file"
                    accept=".pdf"
                    name="tax_invoice_document"
                   onChange={(event) => {
                      validateFileType(event);
                      // Additional onChange logic if needed
                    }}
                    {...register("tax_invoice_document", {
                      required: "This is required.",
                      validate: {
                        lessThan10MB: (files) => {
                          let isValid = true;
                          for (let i = 0; i < files.length; i++) {
                            if (files[i].size > 10485760) {
                              isValid = false;
                              break; // Exit loop if any file exceeds 20MB
                            }
                          }
                          return (
                            isValid || "Max size for each file is 10MB"
                          );
                        },
                      },
                    })}
                  />
                  {errors.tax_invoice_document && (
                    <ErrorLabel message={errors.tax_invoice_document?.message} />
                  )}
                </div>
                <div className="col-12">
                  <small className="fs-7">Only pdf allowed.
                  </small>
                </div>
                <div className="col-12 mt-2">
                  <small className="fs-7"><i>Tax Invoice is mandatory for issuance of Insurance policy.</i></small>
                </div>
                <div className="form-actions border-0 float-none mt-4">
                  <button
                    id="payment_submit"
                    className="btn btn-primary shadow round text-uppercase me-2"
                    type="submit"
                  >
                    <div className="d-flex align-items-center">
                      Submit
                      <span
                        id="payment_submit-loader"
                        className="spinner-border spinner-border-sm ml-half d-none"
                      ></span>
                    </div>
                  </button>
                  <button
                    className="btn btn-outline-secondary mr-1 shadow round text-uppercase"
                    onClick={(event) => {
                      props.handleClose();
                      event.preventDefault();
                    }}
                  >
                    {" "}
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadPaymentDetailsPopup;
